import { createTheme  } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';

const Theme = {
  palette: {
    primary: {
      main: '#e30613',
      light: '#e3061333',
      dark: '#151540',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#e30613',
      light: '#e3061333',
      dark: '#005b8e',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D64045',
    },
    warning: {
      main: '#F2B41B',
    },
    success: {
      main: '#5FAB80',
    },
    info: {
      main: '#233B57',
    },
    white: {
      main: '#FFFFFF',
      dark: '#f4f4f4',
      contrastText: '#000',
    },
    black: {
      main: '#000',
      semilight: '#999', 
      light: '#AAA', 
      contrastText: '#FFF',
    },
  },
  typography: {
    fontFamily: '"Marianne", Arial, sans-serif',
    htmlFontSize: 16,
    h1: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '3rem',
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: 0.84,
      textTransform: 'initial',
    },
    h2: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 26,
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: '32px',
      textTransform: 'initial',
    },
    h3: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 13,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.1,
      textTransform: 'initial',
    },
    h4: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    h5: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    h6: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.25,
    },
    body1: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    body2: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 100,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '1.15rem',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.35,
    },
    button: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: '29px',
      textTransform: 'uppercase',
    },
    overline: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '29px',
    },
    caption: {
      fontFamily: '"Marianne", Arial, sans-serif',
      fontSize: '0.9rem',
      fontWeight: 300,
      letterSpacing: 0,
      lineHeight: 1.2857,
    },
  },
  components: {
    MuiChip: {      
      styleOverrides: {
        root: {
          paddingLeft: 12,
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'display'},
          style: {            
            display: 'inline-block',
            textTransform: 'capitalize',
            padding: '8px 16px',
            margin: '8px !important',
            backgroundColor: '#4777AE',
            color: '#FFFFFF',
            minWidth: 100,
            textAlign: 'center',
            pointerEvents: 'none',
          },
        },
      ],
    },
  },
};

export default createTheme(Theme, frFR);
